import { gql } from '@apollo/client'

import { CUSTOMER_FRAGMENT } from '../fragments/customer'

export const FORGOT_PASSWORD_CUSTOMER = gql`
  mutation ForgotPasswordCustomer($email: String!, $phone: Phone) {
    forgotPasswordCustomer(input: { email: $email, phone: $phone }) {
      state
      success
    }
  }
`

export const SIGN_UP_CUSTOMER = gql`
  mutation SignUpCustomer($input: SignUpCustomerInput) {
    signUpCustomer(input: $input) {
      customer {
        ...Customer
      }
      state
    }
  }
  ${CUSTOMER_FRAGMENT}
`

export const LOGOUT_CUSTOMER = gql`
  mutation LogoutCustomer {
    logoutCustomer {
      __typename
    }
  }
`
